import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    Typography,
    Form,
    message,
    Modal,
    Input,
    InputNumber,
    setParamsFilter,
    Select,
    Switch,
    Textarea,
    Radio,
    ExpandableText,
    useCRUDController,
    PostButton
} from "../../ui/ot";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Search, Settings, Download, RefreshCw, Trash2, Plus, Clock, MoreHorizontal } from "lucide-react"

const SystemBackupSettings = () => {

    return (
        <Row>
            <Col span={24}>
                <SystemBackupSettingsTable keyPrefix={'library.backstage.system_backup_settings'} />
            </Col>
        </Row>
    )
}
const SystemBackupSettingsTable = ({
    keyPrefix = 'library.backstage.system_backup_settings',
    propsSubscriptionid,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef(null);
    const navigate = useNavigate();
    const [tempData, setTempData] = useState([
        {
            "backup_file": "backup_20250301.sql",
            "backup_time": "2025-03-01 03:15:00",
            "backup_creator": "最高權限管理員",
            "backup_description": "自動備份"
        },
        {
            "backup_file": "backup_20250315.sql",
            "backup_time": "2025-03-15 03:15:00",
            "backup_creator": "最高權限管理員",
            "backup_description": "手動備份"
        },
        {
            "backup_file": "backup_20250320.sql",
            "backup_time": "2025-03-20 03:15:00",
            "backup_creator": "最高權限管理員",
            "backup_description": "手動備份"
        },
        {
            "backup_file": "backup_20250325.sql",
            "backup_time": "2025-03-25 03:15:00",
            "backup_creator": "最高權限管理員",
            "backup_description": "自動備份"
        },
        {
            "backup_file": "backup_20250330.sql",
            "backup_time": "2025-03-30 03:15:00",
            "backup_creator": "最高權限管理員",
            "backup_description": "手動備份"
        },
    ]);

    const columns = [
        {
            title: t('backup_file'),
            dataIndex: "backup_file",
            key: "backup_file",
            
        },
        {
            title: t('backup_time'),
            dataIndex: "backup_time",
            key: "backup_time",
             
        },
        {
            title: t('backup_creator'),
            dataIndex: "backup_creator",
            key: "backup_creator",
            

        },
        {
            title: t('backup_description'),
            dataIndex: "backup_description",
            key: "backup_description",
            
        },

    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [axiosMode, setAxiosMode] = useState("get");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.customer_service_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.customer_service_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.customer_service_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.customer_service_id
                );
                selectRow = selectRow.filter(
                    (row) => row.customer_service_id !== record.customer_service_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };

    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    };
    const {
        getData,
        postData,
        patchData,
        deleteData,
        ResponseData,
    } = useCRUDController({
        apiRoute: "/koha/serial",
        onFinish,
        onBefore,
    });
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const locController = useCRUDController({ apiRoute: "/koha/authorised_values" })
    const vendorController = useCRUDController({ apiRoute: "/koha/vendor" })
    const numberingpatternController = useCRUDController({ apiRoute: "/koha/serial/numberingpattern" })

    useEffect(() => {
        checkAll();
        libraryController.getData({})
        locController.getData({ category: "LOC" })
        vendorController.getData({})
        numberingpatternController.getData({})
    }, []);

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}  >
                <div className="flex items-center text-sm text-muted-foreground">
                    <Clock className="mr-2 h-4 w-4" />
                    <span>將於 23:50 自動備份</span>
                    <Button
                        variant="outline"
                        size="sm"
                        className="ml-4 bg-amber-50 text-amber-600 border-amber-200 hover:bg-amber-100 hover:text-amber-700"
                    >
                        {t('change_time')}
                    </Button>
                </div>
            </Col>
            <Col span={24}>
                <ProTableOt
                    formMode={true}
                    rowKey={"subscriptionid"}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return {
                            data:tempData,
                            total:tempData.length
                        }
                    }}
                    toolBarRender={() => {
                        return [
                            <PostButton 
                            onClick={()=>{
                                message.info("系統備份中，需要一段時間，可以離開畫面操作")
                            }}
                            childrenText={"備份"} >
                                新增備份
                            </PostButton >
                        ];
                    }}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: selectedRowsInfo,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={true}
                    propsPatchOnBefore={(record) => {
                        return { ...record }
                    }}
                    PropsPatchForm={<SystemBackupSettingsForm
                        venderOptions={vendorController?.ResponseData}
                        libraryOptions={libraryController?.ResponseData}
                        locOptions={locController?.ResponseData}
                        numberingpatternOptions={numberingpatternController?.ResponseData}
                    />}

                    propsPatch={false}
                    propsPatchProcess={(record) => {
                        // let newRecord = transformData(record)
                        return { ...record }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={true}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}
                    extraActionRender={(record) => {
                        return <Row gutter={[8, 8]}>
                            <Col>
                                <Button
                                    type="default"
                                    className="border-gray-200 text-gray-600 hover:bg-gray-100"
                                    onClick={() => {
                                    }}>
                                    <Download className="h-3.5 w-3.5" />{t('download_file')}
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    className=" border-blue-200 bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700"
                                    onClick={() => {
                                    }}>
                                    <RefreshCw className="h-3.5 w-3.5" />  {t('restore_data')}
                                </Button>
                            </Col>


                        </Row>
                    }}
                    propsPost={false}
                    propsPostOnBefore
                    initialValues={{}}
                    propsWidth={1800}

                />
            </Col>
        </Row>
    );
};

const SystemBackupSettingsForm = (
    {
        keyPrefix = 'library.backstage.system_backup_settings',
        propsForm,
        field,
        initialValues,
        defaultValue,
        onFormFinish = () => { },
        propsOnValuesChange = () => { },
        venderOptions,
        libraryOptions,
        locOptions,
        frequencyOptions,
        numberingpatternOptions

    }) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_

    const { t } = useTranslation('translation', { keyPrefix })
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        let changeValue = form.getFieldValue(name)
        let nameSplit = name.split(".")

        if (nameSplit.includes("numbering_pattern")) {
            nameSplit = nameSplit.slice(0, -1);
            if (nameSplit.length > 1) {
                let newName = nameSplit.join('.')
                let thisValues = form.getFieldValue(newName)
                console.log({
                    thisValues,
                    numberingpatternOptions,
                })
                let selectedNumberingpatternValues = (numberingpatternOptions || [])?.find((ele) => ele?.id === changeValue)

                if (selectedNumberingpatternValues) {
                    delete selectedNumberingpatternValues.id
                }
                selectedNumberingpatternValues = {
                    ...selectedNumberingpatternValues,

                    patternname: selectedNumberingpatternValues?.label,
                    //暫時
                    "ccode": null,
                    "irreg_check": 0,
                    "issuelengthcount": null,
                    "staffdisplaycount": null,
                    "itemtype": null,
                    "mana_id": null,
                    "published_on_template": null,
                }

                let finalValues = {
                    ...thisValues,
                    ...selectedNumberingpatternValues
                }

                form.setFieldValue(newName, finalValues)
            }
            else {
                let newName = nameSplit.join('.')
            }
        }

    };
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const locController = useCRUDController({ apiRoute: "/koha/authorised_values" })
    const vendorController = useCRUDController({ apiRoute: "/koha/vendor" })
    const frequencyController = useCRUDController({ apiRoute: "/koha/serial/periodicity" });
    const numberingpatternController = useCRUDController({ apiRoute: "/koha/serial/numberingpattern" })
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        if (!libraryOptions) {
            libraryController.getData({})
        }
        if (!locOptions) {
            locController.getData({
                category: "LOC",
            })
        }
        if (!venderOptions) {
            vendorController.getData({})
        }
        if (!frequencyOptions) {
            frequencyController.getData({})
        }
        if (!numberingpatternOptions) {
            numberingpatternController.getData({})
        }
    }, [])
    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                                form={form}
                                libraryOptions={libraryOptions ? libraryOptions : libraryController?.ResponseData}
                                locOptions={locOptions ? locOptions : locController?.ResponseData}
                                venderOptions={venderOptions ? venderOptions : vendorController?.ResponseData}
                                numberingpatternOptions={numberingpatternOptions ?? numberingpatternController?.ResponseData}
                                frequencyOptions={frequencyOptions ?? frequencyController.ResponseData}
                            />
                        </Col>

                    </Row>
                </Form>
            </Col>
        </Row>
    );

}
const FormItemComponent = ({
    form,
    keyPrefix,
    field,
    initialValues = {},
    libraryOptions = [],
    locOptions = [],
    venderOptions = [],
    numberingpatternOptions = [],
    frequencyOptions = []
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            labelCol={3}
                            {...field}
                            name={[field?.name ?? '', 'biblionumber']}
                            fieldKey={[field?.fieldKey ?? '', 'biblionumber'].join('.')}
                            hidden={true}
                        >
                            <div></div>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'itemnumber']}
                            fieldKey={[field?.fieldKey ?? '', 'itemnumber'].join('.')}
                            hidden={true}

                        >
                            <div></div>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`vendor`)}
                            name={[field?.name ?? '', 'aqbooksellerid']}
                            fieldKey={[field?.fieldKey ?? '', 'aqbooksellerid'].join('.')}
                        >
                            <Select
                                options={venderOptions.map((value) => {
                                    return {
                                        label: value?.name,
                                        value: value?.id
                                    }
                                })}

                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} >
                                <Form.Item
                                    {...field}
                                    label={t(`biblionumber`)}
                                    name={[field?.name ?? '', 'biblionumber']}
                                    fieldKey={[field?.fieldKey ?? '', 'biblionumber'].join('.')}
                                    labelCol={12}
                                    wrapperCol={12}
                                    disabled={true}
                                    rules={[{ required: true, message: t('please_input_item') }]}

                                >
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                <Form.Item
                                    {...field}
                                    label={t(`bibliographic_title`)}
                                    name={[field?.name ?? '', 'title']}
                                    fieldKey={[field?.fieldKey ?? '', 'title'].join('.')}
                                    disabled={true}
                                >
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`received_serial_number`)}
                            name={[field?.name ?? '', 'serialsadditems']}
                            fieldKey={[field?.fieldKey ?? '', 'serialsadditems'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Radio.Group>
                                <Radio value={1}>
                                    {t('create_item_record')}
                                </Radio>
                                <Radio value={0}>
                                    {t('do_not_create_item_record')}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`irregular_issue`)}
                            name={[field?.name ?? '', 'skip_serialseq']}
                            fieldKey={[field?.fieldKey ?? '', 'skip_serialseq'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Radio.Group>
                                <Radio value={1}>
                                    {t('skip_issue_number')}

                                </Radio>
                                <Radio value={0}>
                                    {t('keep_issue_number')}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`manual_record_change`)}
                            name={[field?.name ?? '', 'manualhistory']}
                            fieldKey={[field?.fieldKey ?? '', 'manualhistory'].join('.')}
                        >
                            <Switch
                                checkedChildren={t('yes')}
                                unCheckedChildren={t('no')}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`call_number`)}
                            name={[field?.name ?? '', 'callnumber']}
                            fieldKey={[field?.fieldKey ?? '', 'callnumber'].join('.')}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`library`)}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode'].join('.')}
                        >
                            <Select options={libraryOptions.map((option) => {
                                if (!!option?.label) {
                                    return {
                                        ...option
                                    }
                                }
                                else {
                                    return {
                                        label: option?.branchname,
                                        value: option?.branchcode,
                                    }
                                }
                            })} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`public_note`)}
                            name={[field?.name ?? '', 'notes']}
                            fieldKey={[field?.fieldKey ?? '', 'notes'].join('.')}
                        >
                            <Textarea />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`internal_note`)}
                            name={[field?.name ?? '', 'internalnotes']}
                            fieldKey={[field?.fieldKey ?? '', 'internalnotes'].join('.')}
                        >
                            <Textarea />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`subscriber_notification`)}
                            name={[field?.name ?? '', 'letter']}
                            fieldKey={[field?.fieldKey ?? '', 'letter'].join('.')}
                            hidden={true}
                        >
                            <Select options={[]} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`shelving_location`)}
                            name={[field?.name ?? '', 'location']}
                            fieldKey={[field?.fieldKey ?? '', 'location'].join('.')}
                        >
                            <Select options={locOptions.map((option) => {
                                if (!!option?.label) {
                                    return {
                                        ...option
                                    }
                                }
                                else {
                                    return {
                                        label: option?.description,
                                        value: option?.authorised_value,
                                    }
                                }
                            })} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`grace_period`) + `(${t(`day`)})`}
                            name={[field?.name ?? '', 'graceperiod']}
                            fieldKey={[field?.fieldKey ?? '', 'graceperiod'].join('.')}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`subscription_start_date`)}
                            name={[field?.name ?? '', 'startdate']}
                            fieldKey={[field?.fieldKey ?? '', 'startdate'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Input type={'date'} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`subscription_end_date`)}
                            name={[field?.name ?? '', 'enddate']}
                            fieldKey={[field?.fieldKey ?? '', 'enddate'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Input type={'date'} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`numbering_pattern`)}
                            name={[field?.name ?? '', 'numbering_pattern']}
                            fieldKey={[field?.fieldKey ?? '', 'numbering_pattern'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Select
                                options={numberingpatternOptions?.map((val) => {
                                    return {
                                        ...val,
                                        label: val?.label,
                                        value: val?.id
                                    }
                                })}
                            />

                        </Form.Item>
                    </Col>

                </Row>
            </Col>
        </Row>
    );
};

export default SystemBackupSettings
export { SystemBackupSettingsTable, SystemBackupSettingsForm }
